import React from 'react'

import { Route, BrowserRouter, Routes } from 'react-router-dom'

import { GoBackConfig } from '@utils/goBackConfig'
import {
  RootPage,
  Contratos,
  AutorizacaoCTPS,
  AutorizacaoINSS,
  OfertaSeguro,
  ResultadoSimulacao,
  CarregamentoSimulacao,
  CarregamentoFormalizacao,
  Revisao,
  VerificacaoRedirecionamento,
  VisualizarTermo,
  Termos,
  Sucesso,
  StatusDocumentos,
  ModoEnvio,
  FotoDocumento,
  SemEmprestimo,
  Endereco,
  DadosBancarios,
  InformacoesPessoais,
  Indisponivel,
  ServicoIndisponivel,
  ModoEnvioContracheque,
  FotoContraCheque,
  Desqualificacao,
  INSSBloqueado,
  BeneficioBloqueado,
  INSSIndisponivel,
  Erro,
  FAQ,
  DocumentoIdentificacao,
  Tutorial,
  BiometriaLiveness,
} from '@pages'

import routes from './routes'
import RequireAuth from './RequireAuth'

const RoutesRefin: React.FC = () => (
  <>
    <BrowserRouter>
      <GoBackConfig />
      <Routes>
        <Route element={<RequireAuth />}>
          <Route path={routes.SEM_EMPRESTIMO} element={<SemEmprestimo />} />
          <Route path={routes.INDISPONIVEL} element={<Indisponivel />} />
          <Route path={routes.SERVICO_INDISPONIVEL} element={<ServicoIndisponivel />} />
          <Route path={routes.ENDERECO} element={<Endereco />} />
          <Route path={routes.DADOS_BANCARIOS} element={<DadosBancarios />} />
          <Route path={routes.INFORMACOES_PESSOAIS} element={<InformacoesPessoais />} />
          <Route path={routes.SUCESSO} element={<Sucesso />} />
          <Route path={routes.TERMO_VISUALIZACAO} element={<VisualizarTermo />} />
          <Route path={routes.TERMOS_CONTRATACAO} element={<Termos />} />
          <Route path={routes.REVISAO} element={<Revisao />} />
          <Route path={routes.STATUS_DOCUMENTO} element={<StatusDocumentos />} />
          <Route path={routes.MODO_ENVIO} element={<ModoEnvio />} />
          <Route path={routes.FOTO_DOCUMENTO} element={<FotoDocumento />} />
          <Route path={routes.MODO_ENVIO_CONTRA_CHEQUE} element={<ModoEnvioContracheque />} />
          <Route path={routes.FOTO_CONTRA_CHEQUE} element={<FotoContraCheque />} />
          <Route path={routes.CARREGAMENTO_SIMULACAO} element={<CarregamentoSimulacao />} />
          <Route path={routes.CARREGAMENTO_FORMALIZACAO} element={<CarregamentoFormalizacao />} />
          <Route path={routes.RESULTADO_SIMULACAO} element={<ResultadoSimulacao />} />
          <Route path={routes.OFERTA_SEGURO} element={<OfertaSeguro />} />
          <Route path={routes.AUTORIZACAO_CTPS} element={<AutorizacaoCTPS />} />
          <Route path={routes.AUTORIZACAO_INSS} element={<AutorizacaoINSS />} />
          <Route path={routes.CONTRATOS} element={<Contratos />} />
          <Route path={routes.DESQUALIFICACAO} element={<Desqualificacao />} />
          <Route path={routes.ERRO} element={<Erro />} />
          <Route path={routes.INSS_BLOQUEADO} element={<INSSBloqueado />} />
          <Route path={routes.BENEFICIO_BLOQUEADO} element={<BeneficioBloqueado />} />
          <Route path={routes.INSS_INDISPONIVEL} element={<INSSIndisponivel />} />
          <Route path={routes.FAQ} element={<FAQ />} />
          <Route path={routes.TUTORIAL} element={<Tutorial />} />
          <Route path={routes.DOCUMENTO_IDENTIFICACAO} element={<DocumentoIdentificacao />} />
          <Route path={routes.BIOMETRIA_LIVENESS} element={<BiometriaLiveness />} />
        </Route>

        <Route path={routes.VERIFICACAO} element={<VerificacaoRedirecionamento />} />

        <Route path={routes.ROOT} element={<RootPage />} />
        <Route path={routes.REFIN} element={<RootPage />} />
        <Route path={routes.REFIN_v2} element={<RootPage />} />
        <Route path={routes.SEM_EMPRESTIMO_V1} element={<RootPage />} />
        <Route path={routes.CONFIRMAR_CONTATO_V1} element={<RootPage />} />
        <Route path={routes.DADOS_RECEBIDOS_V1} element={<RootPage />} />
        <Route path={routes.CONTRATOS_V1} element={<RootPage />} />
        <Route path={routes.RESULTADO_V1} element={<RootPage />} />
        <Route path={routes.PARCELAMENTO_V1} element={<RootPage />} />
        <Route path={routes.NAO_LIBERADO_V1} element={<RootPage />} />
        <Route path={routes.AUTORIZACAO_V1} element={<RootPage />} />
        <Route path={routes.SIMULACAO_V1} element={<RootPage />} />
        <Route path={routes.ONBOARDING_CONTRATO_V1} element={<RootPage />} />
        <Route path={routes.CONFERIR_REFINANCIAMENTO_V1} element={<RootPage />} />
        <Route path={routes.LISTA_DOCUMENTOS_V1} element={<RootPage />} />
        <Route path={routes.VISUALIZAR_DOCUMENTO_V1} element={<RootPage />} />
      </Routes>
    </BrowserRouter>
  </>
)
export default RoutesRefin
